import { CdkScrollable } from "@angular/cdk/overlay";
import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Inject, OnDestroy, ViewChild, } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Subscription } from "rxjs";
import { auditTime } from "rxjs/operators";

export interface TermsComponentData {
  scrollToPrivacyPolicy?: boolean;
}

@Component({
    selector: "app-terms",
    templateUrl: "./terms.component.html",
    styleUrls: ["./terms.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TermsComponent implements AfterViewInit, OnDestroy {
  private readonly subs = new Subscription();
  @ViewChild("privacyPolicy", { read: ElementRef }) privacyPolicy: ElementRef<any>;
  @ViewChild(CdkScrollable) scrollable: CdkScrollable;
  scrolledToEnd: boolean = false;

  constructor(
    private readonly changeRef: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) private readonly data: TermsComponentData
  ) {}

  ngAfterViewInit() {
    this.subs.add(
      this.scrollable
        ?.elementScrolled()
        .pipe(auditTime(100))
        .subscribe((x) => {
          const scrollTop = x.target["scrollTop"];
          const scrollHeight = x.target["scrollHeight"];
          const clientHeight = x.target["clientHeight"];

          if ((scrollTop + clientHeight) / scrollHeight > 0.95) {
            this.scrolledToEnd = true;
            this.changeRef.detectChanges();
          }
        })
    );
    if (this.data && this.data.scrollToPrivacyPolicy) {
      this.scrollable?.scrollTo({ top: this.privacyPolicy.nativeElement.offsetTop - 200 });
    }
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
